//import {Injectable, EventEmitter} from "@angular/core";
import {Injectable} from '@angular/core';
// import {Http, Response, Headers, RequestOptions} from "@angular/http";
//import * as constants from '../config/constants';
import { Storage } from '@ionic/storage-angular';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { GlobalDataService } from './global-data.service';
import { v4 as uuidv4 } from 'uuid';
import { AuthService } from 'src/services/auth.service';
import { AuthHttpService } from 'src/services/auth-http.service';
import { body } from 'ionicons/icons';

@Injectable()
export class FileServices {

  userLogged: any;
  headers: HttpHeaders;
  url: string;
  localAgentId: string;
  localSessionToken: string;
  environment: any;
  constructor (
                public http: HttpClient,
                private gds: GlobalDataService,
                public localStorage: Storage,
                private authService: AuthService,
                private authHttpService: AuthHttpService,)
    {
      this.headers = new HttpHeaders();
      this.headers = this.headers.set('Content-Type', 'application/json');
      //this.headers = this.headers.set('X-DreamFactory-API-Key', environment.XDreamFactoryAPIKey);
      this.gds.getAgentId().subscribe(
        (data: any) => {
          if (data === undefined || data===null || data==='') {
            console.log('Skipping Agent Id as data is undefined');
          }
          else {
            //console.log('Setting X-Exme-Agent-Id value');
            console.log(data);
            this.headers = this.headerSet( this.headers,'X-Exme-Agent-Id', data.toString());
            //console.log('Current Header are');
            //console.log(this.headers);
          }

          if (data) {
            this.localAgentId = data;
          }
        }
      );

      this.gds.getLogout().subscribe(
        (data: any) => {
          if (data == 1) {
            this.localAgentId=undefined;
            this.localSessionToken=undefined;
          }
        }
      );

      this.gds.getaccess_token().subscribe(
        (data: string) => {
          if (data === undefined || data===null || data==='') {
            console.log('Skipping Session Token as data is undefined');
          }
          else {
            console.log('X-ExME-Session-Token');
            this.headers = this.headerSet(this.headers,'X-ExME-Session-Token', data);
            //console.log('Current Header are');
            //console.log(this.headers);
          }

          if (data) {
            this.localSessionToken = data;
          }
        }
      );

//      this.headers = this.headers.set('Access-Control-Allow-Origin', '*');
      this.userLogged = localStorage.get('userSession');
    }



  loadNewUserAvatar(file: File | Blob, fileName: string) {
    const formData = new FormData();
    const safeName = (fileName || 'avatar.png').replace(/[^a-zA-Z0-9._-]/g, '_');
    const safeFilePath = 'avatars/';
    formData.append('content', file);
    formData.append('filePath', safeFilePath);

    /*const body =
    {
        'name': fileName,
    		'type': 'file',
    		'is_base64': true,
    		'content': image
    };*/

    return this.localMakeRequestCapacitor('uploadAvatar',formData,'ExMEPublic','uploadAvatar',null,false);
  }

  readUserAvatar(filePath: string) {
    const body = {
      'filePath': filePath
    };

    return this.localMakeRequestCapacitor('readAvatar',body,'ExMEPublic','readAvatar',null,false);
  }


//   loadGroupLogo(image: any, fileName: string) {
//     const body =
//     {
//       'resource': [{
//         'name': fileName,
//     		'type': 'file',
//     		'is_base64': true,
//     		'content': image
//       }]
//     };
//     //let url = environment.apiUrl + 'api/v2/files/group_logo/';
//     const url = `${environment.apiUrl}files/group_logo/`;
//     return this.http.post(url, body, {headers: this.headers}).pipe(
//       map(this.extractData),
//       catchError(this.handleError)
//     );
// //      .map((response: Response) => response.json())

//   }

  async localMakeRequestCapacitor(
    callFunction: string,
    body: any,
    service: string,
    operation: string,
    agentId: string,
    deleteSession: boolean,
    forceAgent: boolean = false) 
    {
      const bodyStringified = JSON.stringify(body);
    if(service === 'ExMEPublic' || service === 'ExMESecure'){
      this.environment = environment.apiPilot;
    } else {
      // this.environment = environment.apiUrl;
    }
    

    let url = '';
    if(operation === 'uploadSticker'){
      url = `${this.environment}` + 'gallery' + '?' + 'operation=' + operation ;
    } else {
      url = `${this.environment}` + service + '?' + 'operation=' + operation ;
    }
    //const url = `${this.environment}` + service + '?' + 'operation=' + operation ;
    //console.log('110226 -', url);

    return new Promise((resolve, reject) => {
      let headers: any = {
        'Content-Type': 'application/json',
      };

      console.log('Headers:', headers);

      /*if (service === 'ExMESecure' || service === 'ExMEFinGen') {
        headers['X-Exme-Agent-Id'] =
          forceAgent === true
            ? agentId
            : this.localAgentId === undefined
            ? agentId
            : this.localAgentId;
      }*/

      console.log('Final Headers:', headers);

      if (deleteSession) {
        delete headers['X-ExME-Session-Token'];
      }

      const options = {
        url: url,
        headers: headers,
        data: body,
      };

      console.log('Request Options:', options);

      this.authHttpService.authenticatedPost(options)
        .then((data) => {
          console.log('API Response:', data);
          resolve(data);
        })
        .catch((error) => {
          console.error('API Error:', error);
          reject(error);
        });
    });
  }

  private headerSet(sourceHeader: HttpHeaders, changeKey: string, changeValue: any){
    let retHeader=new HttpHeaders();
    sourceHeader.keys().forEach( (key) => {
      if ( key !== changeKey){
        retHeader=retHeader.append(key,sourceHeader.get(key));
      } else {
      }
    });
    if ( changeValue !== undefined && changeValue !== null && changeValue !== '') {
      retHeader=retHeader.append(changeKey,changeValue);
//      console.log('Appending Key');
    }
//    console.log('Returning:');
//    console.log(retHeader);
    return retHeader;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `error message was: ${error.error.error.message}`);
    }
    return throwError('Something bad happened; please try again later.');
  }

  private extractData(res: Response) {
    const body = res;
    return body || { };
  }

}
